module.exports = __webpack_public_path__ + "img/outpatientPersonTimeSecond.13a212f4.svg";